<template>
	<card title="Temperature" icon="temperature">
		<div class="sk-group" v-if="hasData">
			<div class="sk-group-l">
				<div><span class="sk-value-highlight"><b>{{ roundValue(data.last) }}</b> ºC</span></div>
			</div>
			<div class="sk-group-m items-3">
				<div><span class="sk-value">{{ roundValue(data.avg) }}</span><span class="sk-title">Average</span></div>
				<div><span class="sk-value">{{ data.max }}</span><span class="sk-title">Highest</span></div>
				<div><span class="sk-value">{{ data.min }}</span><span class="sk-title">Lowest</span></div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
		<template v-slot:more-options>
			<card-option-item-link route="WatchBiometricView" :args="{ watch_id: patient.id, type: 'temperature' }" :title="$t('See More')" />
		</template>
	</card>
</template>

<script>
import { mapGetters } from 'vuex'
import CardOptionItemLink from '@/modules/common/CardOptionItemLink'
import Card from '@/modules/common/Card'
import Datetime from '@/utils/Datetime'
export default {
	name: 'card-pacient-temperature',
	components: {
		Card,
		CardOptionItemLink
	},
	props: {
		patient: {
			type: Object,
			default: () => ({
				profile: {},
				readings: []
			})
		},
		datetime: {
			type: Object,
			default: () => ({
				minute: 0,
				hour: 0,
				day: 0,
				month: 0,
				year: 0
			})
		}
	},
	data() {
		return {
			type: 3,
			default: {},
			readings: []
		}
	},
	computed: {
		hasData: function() {
			return this.readings.length > 0
		},
		data: function() {
			const list = this.readings
			if (list.length === 0)
				return this.default
			const reading = list.sort((a1, a2) => a1.key - a2.key)[0]
			return reading.base
		},
		...mapGetters({
			getPatientByType: 'PATIENTS_READINGS_BY_TYPE'
		}),
	},
	methods: {
		roundValue: (value) => Number.parseFloat(value).toFixed(2),
		refresh() {
			this.readings = this.getPatientByType(this.patient, this.type, Datetime.toKey(this.datetime))
		}
	},
	watch: {
		datetime(newValue, oldValue) {
			this.refresh()
		}
	},
	created() {
		this.refresh()
	}
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientTemperature.vue